<template>
  <Loader style="z-index: 10000" v-if="loader" />
  <div class="card">
    <div class="grid mb-6 align-items-end">
      <!-- Tipo fornitura -->
      <div class="col-12 md:col-3">
        <label>Tipo fornitura</label>
        <Dropdown
          v-model="selectedTypeFornitura"
          :options="typesFornitura"
          optionLabel="name"
          optionValue="name"
          class="inputfield w-full"
        />
      </div>

      <!-- Data Decorrenza -->
      <div class="col-12 md:col-3">
        <label>Data Decorrenza</label>
        <Calendar
          v-model="selectedDateDecorrenza"
          dateFormat="mm-yy"
          view="month"
          class="inputfield w-full"
          @date-select="onSelectDates('data_decorrenza')"
          showIcon
        />
        <div
          v-show="validationErrors.data_decorrenza && submitted"
          class="p-error"
        >
          Campo richiesto.
        </div>
      </div>

      <!-- Data Pratica -->
      <div class="col-12 md:col-3">
        <label>Data Pratica</label>
        <Calendar
          v-model="selectedDatePratica"
          dateFormat="mm-yy"
          selectionMode="range"
          view="month"
          class="inputfield w-full"
          @date-select="onSelectDates('data_pratica')"
          showIcon
        />
        <div
          v-show="validationErrors.data_pratica && submitted"
          class="p-error"
        >
          Campo richiesto.
        </div>
      </div>

      <div class="col-12 md:col-3">
        <div class="flex align-items-center justify-content-center mt-3 mt-md-0">
          <Checkbox
            inputId="mostraAnnullati"
            v-model="showAnnullati"
            binary
          />
          <label for="mostraAnnullati" class="ml-2">
            Mostra annullati
          </label>
        </div>
      </div>

      <div class="col-12 mt-3">
        <div class="flex justify-content-center">
          <Button
            label="Cerca"
            @click="searchData"
            icon="pi pi-search"
            iconPos="left"
          />
        </div>
      </div>
    </div>

    <!-- <hr> -->

    <TabView class="switchout-check ">
      <TabPanel>
        <template #header>
          <div class="flex align-items-center gap-2">
            <p>SWITCH-OUT</p>
            <Badge :value="'swout' in items ? items.swout.length : '0'" class="ml-3" />
          </div>
        </template>
        <DataTable ref="dt_swout" :value="items.swout" tableStyle="width: 100%" dataKey="fornitura" responsiveLayout="scroll" v-model:filters="filters" :paginator="true" :rows="100" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rowsPerPageOptions="[10, 20, 50, 100, 500]" currentPageReportTemplate="{first} a {last} di {totalRecords}" exportFilename="SWITCH-OUT" csvSeparator=";" :rowClass="rowClassSwoutAnnullati">
          <template #header>
            <div class="flex justify-content-between flex-wrap">
              <div class="flex align-items-center justify-content-center mb-2">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    type="search"
                    v-model="filters['global'].value"
                    placeholder="Cerca..."
                  />
                </span>
              </div>
              <div class="flex align-items-center justify-content-center">
                <Button v-if="exist_bimestrali" icon="pi pi-send" :label="`${exist_bimestrali} contratti bimestrali`" @click="changeBimestrali" class="p-button-warning mx-2" v-tooltip="`Imposta in contratto mensile`" />
                <Button
                  icon="pi pi-download"
                  label="Esporta"
                  @click="exportCSV('swout')"
                  class="p-button-secondary mx-2"
                />
              </div>
            </div>
          </template>
          <template #empty>
            <div class="text-center">Nessun dato trovato.</div>
          </template>
          <Column field="cod_servizio" header="Cod.Servizio" :sortable="true" />
          <Column field="fornitura" header="Fornitura" :sortable="true">
            <template #body="{ data }">
              {{ data.fornitura }}
            </template>
          </Column>
          <Column
            field="protocollo"
            header="Protocollo"
            :sortable="true"
          />
          <Column
            field="data_inizio_fornitura"
            header="Data Inizio"
            :sortable="true"
          >
            <template #body="{ data }">
              {{
                data.data_inizio_fornitura != null
                  ? formatDate(data.data_inizio_fornitura)
                  : ""
              }}
            </template>
          </Column>
          <!-- <Column field="data_fine_fornitura" header="Data Fine" :sortable="true">
          <template #body="{ data }">
            {{ data.data_fine_fornitura != null ? formatDate(data.data_fine_fornitura) : '' }}
          </template>
        </Column> -->
          <Column
            field="data_decorrenza"
            header="Data Decorrenza"
            :sortable="true"
          >
            <template #body="{ data }">
              {{
                data.data_decorrenza != null
                  ? formatDate(data.data_decorrenza)
                  : ""
              }}
            </template>
          </Column>
          <Column field="cliente" header="Cliente" :sortable="true" />
          <Column
            field="rappresentante"
            header="Rappresentante"
            :sortable="true"
          />
          <Column field="agente" header="Agente" :sortable="true" />
          <Column field="is_point" header="Point" :sortable="true">
            <template #body="{ data }">
              {{ Boolean(data.is_point) ? data.agente_firmatario : "No" }}
            </template>
          </Column>
          <!-- <Column field="provider" header="Provider" :sortable="true" /> -->
          <Column field="type_periodo" header="Fatturazione" :sortable="true" />
          <Column field="type_pay" header="Pagamento" :sortable="true" />
          <Column
            field="saldoCliente"
            header="Saldo Cliente"
            :sortable="true"
          />
          <Column field="saldoPdp" header="Saldo" :sortable="true">          
            <template #body="{ data }">
              {{ Number(data.saldoPdp).toFixed(3) }}
            </template>
          </Column>
          <Column field="consumoAnnuoPdp" header="Consumo Annuo" :sortable="true" />
          <Column field="cc" header="Cc" :sortable="true" />
          <Column field="udd" header="Udd" :sortable="true" />
          <Column
            field="motivazione_esito"
            header="Motivazione"
            :sortable="true"
          />
          <Column field="file_name" header="Filename" :sortable="true" />
        </DataTable>
      </TabPanel>
      <TabPanel>
        <template #header>
          <div class="flex align-items-center gap-2">
            <p>SPOSTAMENTI</p>
            <Badge
              :value="'spostamenti' in items ? items.spostamenti.length : '0'"
              class="ml-3"
            />
          </div>
        </template>
        <DataTable
          ref="dt_spostamenti"
          :value="items.spostamenti"
          tableStyle="width: 100%"
          dataKey="code"
          responsiveLayout="scroll"
          v-model:filters="filters"
          :paginator="true"
          :rows="100"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 50, 100, 500]"
          currentPageReportTemplate="{first} a {last} di {totalRecords}"
          exportFilename="SPOSTAMENTI"
          csvSeparator=";"
        >
          <template #header>
            <div class="flex justify-content-between flex-wrap">
              <div class="flex align-items-center justify-content-center mb-2">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    type="search"
                    v-model="filters['global'].value"
                    placeholder="Cerca..."
                  />
                </span>
              </div>
              <div class="flex align-items-center justify-content-center">
                <Button
                  icon="pi pi-download"
                  label="Esporta"
                  @click="exportCSV('spostamenti')"
                  class="p-button-secondary mx-2"
                />
              </div>
            </div>
          </template>
          <template #empty>
            <div class="text-center">Nessun dato trovato.</div>
          </template>
          <Column field="cod_servizio" header="Cod.Servizio" :sortable="true" />
          <Column field="fornitura" header="Fornitura" :sortable="true">
            <template #body="{ data }">
              {{ data.fornitura }}
            </template>
          </Column>
          <Column
            field="cp_gestore"
            header="Protocollo"
            :sortable="true"
          />
          <Column
            field="data_inizio"
            header="Data Inizio"
            :sortable="true"
          >
            <template #body="{ data }">
              {{
                data.data_inizio != null
                  ? formatDate(data.data_inizio)
                  : ""
              }}
            </template>
          </Column>
          <!-- <Column field="data_fine_fornitura" header="Data Fine" :sortable="true">
          <template #body="{ data }">
            {{ data.data_fine_fornitura != null ? formatDate(data.data_fine_fornitura) : '' }}
          </template>
        </Column> -->
          <Column
            field="data_decorrenza"
            header="Data Decorrenza"
            :sortable="true"
          >
            <template #body="{ data }">
              {{
                data.data_decorrenza != null
                  ? formatDate(data.data_decorrenza)
                  : ""
              }}
            </template>
          </Column>
          <Column field="cliente" header="Cliente" :sortable="true" />
          <Column
            field="rappresentante"
            header="Rappresentante"
            :sortable="true"
          />
          <Column field="agente" header="Agente" :sortable="true" />
          <!-- <Column field="provider" header="Provider" :sortable="true" /> -->
          <Column field="type_periodo" header="Fatturazione" :sortable="true" />
          <Column field="type_pay" header="Pagamento" :sortable="true" />
          <Column
            field="saldoCliente"
            header="Saldo Cliente"
            :sortable="true"
          />
          <Column field="saldoPdp" header="Saldo" :sortable="true" />
          <Column field="consumoAnnuoPdp" header="Consumo Annuo" :sortable="true" />
          <Column field="cc" header="Cc" :sortable="true" />
          <Column field="udd" header="Udd" :sortable="true" />
          <!-- <Column
            field="motivazione_esito"
            header="Motivazione"
            :sortable="true"
          /> -->
        </DataTable>
      </TabPanel>
      <TabPanel>
        <template #header>
          <div class="flex align-items-center gap-2">
            <p>SWITCH-OUT AGENTI</p>
            <Badge
              :value="
                'swout_group' in items
                  ? Object.keys(items.swout_group).length
                  : '0'
              "
              class="ml-3"
            />
          </div>
        </template>
        <div
          v-if="
            'swout_group' in items && Object.keys(items.swout_group).length > 0
          "
          class="flex align-items-center justify-content-end p-2 pr-0"
        >
          <Button
            icon="pi pi-download"
            label="Esporta"
            @click="exportSwoutGroup(items.swout_group)"
            class="p-button-secondary mx-2"
          />
        </div>
        <Accordion lazy>
          <AccordionTab
            v-for="(objs, agentName) in items.swout_group"
            :key="agentName"
          >
            <template #header>
              <span class="flex align-items-center gap-2 w-full">
                <span class="font-bold white-space-nowrap">{{
                  agentName.toUpperCase()
                }}</span>
                <Badge :value="objs.length" class="badge-swout ml-auto mr-2" />
              </span>
            </template>
            <DataTable
              :value="objs"
              tableStyle="width: 100%"
              dataKey="code"
              responsiveLayout="scroll"
              v-model:filters="filters"
              :paginator="true"
              :rows="100"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              :rowsPerPageOptions="[10, 20, 50, 100, 500]"
              currentPageReportTemplate="{first} a {last} di {totalRecords}"
            >
              <template #header>
                <div class="flex justify-content-between flex-wrap">
                  <div
                    class="flex align-items-center justify-content-center mb-2"
                  >
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText
                        type="search"
                        v-model="filters['global'].value"
                        placeholder="Cerca..."
                      />
                    </span>
                  </div>
                  <div class="flex align-items-center justify-content-center">
                    <Button
                      icon="pi pi-download"
                      label="Esporta"
                      @click="exportSwoutGroup({ [agentName]: objs })"
                      class="p-button-secondary mx-2"
                    />
                  </div>
                </div>
              </template>
              <template #empty>
                <div class="text-center">Nessun dato trovato.</div>
              </template>
              <Column
                field="cod_servizio"
                header="Cod.Servizio"
                :sortable="true"
              />
              <Column field="fornitura" header="Fornitura" :sortable="true">
                <template #body="{ data }">
                  {{ data.fornitura }}
                </template>
              </Column>
              <Column
                field="protocollo"
                header="Protocollo"
                :sortable="true"
              />
              <Column
                field="data_inizio_fornitura"
                header="Data Inizio"
                :sortable="true"
              >
                <template #body="{ data }">
                  {{
                    data.data_inizio_fornitura != null
                      ? formatDate(data.data_inizio_fornitura)
                      : ""
                  }}
                </template>
              </Column>
              <!-- <Column field="data_fine_fornitura" header="Data Fine" :sortable="true">
              <template #body="{ data }">
                {{ data.data_fine_fornitura != null ? formatDate(data.data_fine_fornitura) : '' }}
              </template>
            </Column> -->
              <Column
                field="data_decorrenza"
                header="Data Decorrenza"
                :sortable="true"
              >
                <template #body="{ data }">
                  {{
                    data.data_decorrenza != null
                      ? formatDate(data.data_decorrenza)
                      : ""
                  }}
                </template>
              </Column>
              <Column field="cliente" header="Cliente" :sortable="true" />
              <Column
                field="rappresentante"
                header="Rappresentante"
                :sortable="true"
              />
              <Column field="agente" header="Agente" :sortable="true" />
              <!-- <Column field="provider" header="Provider" :sortable="true" /> -->
              <Column
                field="type_periodo"
                header="Fatturazione"
                :sortable="true"
              />
              <Column
                field="saldoCliente"
                header="Saldo Cliente"
                :sortable="true"
              />
              <Column field="saldoPdp" header="Saldo" :sortable="true" />
              <Column field="consumoAnnuoPdp" header="Consumo Annuo" :sortable="true" />
              <Column field="type_pay" header="Pagamento" :sortable="true" />
              <Column field="cc" header="Cc" :sortable="true" />
              <Column field="udd" header="Udd" :sortable="true" />
              <Column
                field="motivazione_esito"
                header="Motivazione"
                :sortable="true"
              />
            </DataTable>
          </AccordionTab>
        </Accordion>
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import Service from "@/services/ask-pratiche/pratiche-service";
import ServiceOperation from "@/services/ask-operation/operation-service";
import { ref, getCurrentInstance, computed, reactive, toRefs } from "vue";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";

export default {
  components: {
    Loader,
  },
  setup() {
    const dt_swout = ref();
    const dt_spostamenti = ref();
    const dt_swout_credito = ref();
    const toast = useToast();
    const loader = ref(false);
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const formatDate = self.appContext.config.globalProperties.$formatDate;
    const service = new Service(self.$http, self.$eventBus);
    const state = reactive({
      items: {
        swout: [],
        spostamenti: [],
        swout_group: {}
      }
    });
    const { items } = toRefs(state);
    const selectedDateDecorrenza = ref(new Date());
    const selectedDatePratica = ref();
    const typesFornitura = ref([{ name: "POD" }, { name: "PDR" }]);
    const selectedTypeFornitura = ref(typesFornitura.value[0].name);
    const validationErrors = ref({});
    const submitted = ref(false);
    const contratti_bimestrali = ref([]);
    const serviceOperation = new ServiceOperation(self.$http, self.$eventBus);
    const buttonStates = ref({});
    const clickedButtons = ref(new Set());
    const showAnnullati = ref(false);

    const isButtonDisabled = computed(() => (id) => {
      return clickedButtons.value.has(id) || buttonStates.value[id];
    });

    const searchData = async () => {
      submitted.value = true;
      validationErrors.value = {};
      if (validateInputs()) {
        loader.value = true;
        let data_decorrenza = selectedDateDecorrenza.value;
        let data_pratica = null;
        if (data_decorrenza != null) {
          data_decorrenza = moment(selectedDateDecorrenza.value).startOf("month").format("YYYY-MM-DD");
        }

        if (selectedDatePratica.value != null) {
          data_pratica = [
            moment(selectedDatePratica.value[0]).startOf("month").format("YYYY-MM-DD"),
            moment(selectedDatePratica.value[0]).endOf("month").format("YYYY-MM-DD"),
          ];
          if (selectedDatePratica.value.length > 1 && selectedDatePratica.value[1] != null) {
            data_pratica[1] = moment(selectedDatePratica.value[1]).endOf("month").format("YYYY-MM-DD");
          }
        }

        await service
          .getSwitchOutCheck(selectedTypeFornitura.value, data_decorrenza, data_pratica, showAnnullati.value)
          .then((res) => {
            state.items = res.items;
            contratti_bimestrali.value = [];
            res.items.swout.forEach((sw) => {
              if (sw.cod_type_periodo == 2 && isWithinRange(sw.data_decorrenza, data_decorrenza)) {
                contratti_bimestrali.value.push(sw.contratto_id);
              }
            });
            res.items.swout.forEach(item => {
              buttonStates.value[item.id_fornitura] = item.cod_pre_sospensione !== null;
            });
          })
          .finally(() => {
            loader.value = false;
          });
      }
    };
    const isWithinRange = (dateString, data_decorrenza) => {
      const startDate = moment(data_decorrenza);
      const endDate = moment(data_decorrenza).endOf('month');      
      const date = moment(dateString);
      return date.isBetween(startDate, endDate, null, '[]'); 
    }

    const exist_bimestrali = computed(() => {
      return contratti_bimestrali.value.length;
    });

    const changeBimestrali = async () => {
      loader.value = true;
      let fd = new FormData();
      fd.append("ids", JSON.stringify(contratti_bimestrali.value));

      service
        .setContrattiMensili(fd)
        .then((res) => {
          let severity = res.items.success ? "success" : "warn";
          let detail = `${res.items.msg}`;
          toast.add({ severity: severity, summary: "", detail: detail });
          items.value = [];
        })
        .finally(() => {
          Promise.all([searchData()]);
        });
    };
    const validateInputs = () => {
      if (
        selectedDateDecorrenza.value == null &&
        selectedDatePratica.value == null
      ) {
        validationErrors.value["data_decorrenza"] = true;
        validationErrors.value["data_pratica"] = true;
      } else {
        delete validationErrors.value["data_decorrenza"];
        delete validationErrors.value["data_pratica"];
      }

      return !Object.keys(validationErrors.value).length;
    };

    const exportSwoutGroup = (objs) => {
      loader.value = true;
      service.exportSwoutGroup(objs).finally(() => {
        loader.value = false;
      });
    };

    const onSelectDates = (type_date) => {
      if (type_date == "data_decorrenza") {
        selectedDatePratica.value = null;
      }
      if (type_date == "data_pratica") {
        selectedDateDecorrenza.value = null;
      }
    };

    const exportCSV = (type) => {
      self.refs[`dt_${type}`].exportCSV();
    };

    const addToPreview = async (data) => {
      loader.value = true;
      try {
        clickedButtons.value.add(data.id_fornitura);
        
        const isPod = selectedTypeFornitura.value.toLowerCase() === 'pod';
        const typeFornitura = isPod ? 'pods' : 'pdrs';
        
        const response = await serviceOperation.createMultiPreSuspensionOrReactivation(
          [{ id: data.id_fornitura }],
          typeFornitura,
          'sospensioni'
        );

        if (response) {
          buttonStates.value[data.id_fornitura] = true;
          
          toast.add({
            severity: 'success',
            summary: 'Successo',
            detail: '1 fornitura/e aggiunta in preview'
          });

          setTimeout(() => {
            searchData();
          }, 100);
        }
      } catch (error) {
        clickedButtons.value.delete(data.id_fornitura);
        
        console.error('Errore:', error); 
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante l\'aggiunta alla preview'
        });
      } finally {
        loader.value = false;
      }
    };

    const getRowClass = (data) => {
      switch (data.name_stato_fornitura) {
        case 'In Sospensione':
          return 'status-in-sospensione';
        case 'Sospeso':
          return 'status-sospeso';
        case 'Sospensione richiesta':
          return 'status-richiesta';
        case 'Sospensione in lavorazione':
          return 'status-in-lavorazione';
        default:
          return '';
      }
    };

    const rowClassSwoutAnnullati = (data) => {
      if (data.motivazione_esito && String(data.motivazione_esito).trim() !== '') {
        return 'row-motivazione-non-vuota';
      }
      return '';
    };

    return {
      dt_swout,
      dt_spostamenti,
      dt_swout_credito,
      loader,
      formatDate,
      filters,
      searchData,
      items,
      selectedDateDecorrenza,
      selectedDatePratica,
      typesFornitura,
      onSelectDates,
      selectedTypeFornitura,
      exportCSV,
      exportSwoutGroup,
      validationErrors,
      submitted,
      contratti_bimestrali,
      exist_bimestrali,
      changeBimestrali,
      addToPreview,
      buttonStates,
      clickedButtons,
      isButtonDisabled,
      getRowClass,
      showAnnullati,
      rowClassSwoutAnnullati
    };
  },
};
</script>
<style>

.p-datatable .row-motivazione-non-vuota > td {
  background-color: #ffe5e5;   /* rosso chiaro */
}

.badge-swout {
  background-color: #d1d3d8 !important;
  color: black !important;
}

.status-in-sospensione {
  background-color: #ffe4c4 !important; 
}

.status-sospeso {
  background-color: #ffe6e6 !important; 
}

.status-richiesta {
  background-color: #e6ffe6 !important; 
}

.status-in-lavorazione {
  background-color: #f3e6ff !important; 
}

.p-datatable .p-datatable-tbody > tr.status-in-sospensione:hover {
  background-color: #ffe4c4 !important;
}

.p-datatable .p-datatable-tbody > tr.status-sospeso:hover {
  background-color: #ffe6e6 !important;
}

.p-datatable .p-datatable-tbody > tr.status-richiesta:hover {
  background-color: #e6ffe6 !important;
}

.p-datatable .p-datatable-tbody > tr.status-in-lavorazione:hover {
  background-color: #f3e6ff !important;
}

.legend-box {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.p-datatable .p-datatable-tbody > tr > td {
  vertical-align: top;
  padding: 0.5rem;
}

.flex-column > span {
  margin-bottom: 0.2rem;
}

.flex-column > span:last-child {
  margin-bottom: 0;
}
</style>

